module.exports = __webpack_public_path__ + "img/tepe.8be9a19d.svg";